import { MaterialIcon } from "@website/icons/material";
import styles from "@website/ui/modal/modal.module.scss";
import { ModalPropertiesType } from "@website/ui/modal/modal.types";
import { TransitionV2 } from "@website/ui/transition";
import { useClientLoaded } from "@website/utils/client-loaded/useClientLoaded";
import { FC, MouseEvent, PropsWithChildren, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
export const Modal: FC<PropsWithChildren<ModalPropertiesType>> = properties => {
  const {
    fullWidth,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    id,
    open,
    fullScreen,
    animate,
    children,
    title,
    onClose,
    showCloseButton,
    mobileHeight,
    className,
    closeIcon = "close",
    headerStyle,
    iconClassName,
    titleClassName = "",
    usePortal,
    wrapperClassName
  } = properties;
  const {
    clientLoaded
  } = useClientLoaded();
  const body = useRef<HTMLElement | null>(typeof document === "undefined" ? null : document.body);
  const stopPropagationOnModal = (event: MouseEvent) => {
    event.stopPropagation();
  };
  useEffect(() => {
    if (open) {
      document.body.classList.add("prevent-scroll");
      return () => document.body.classList.remove("prevent-scroll");
    }
  }, [open]);
  useEffect(() => {
    if (open) {
      const checkIfPressEsc = (event_0: KeyboardEvent) => {
        if (event_0.key === "Escape") {
          onClose?.();
          event_0.stopPropagation();
        }
      };
      document.addEventListener("keydown", checkIfPressEsc);
      return () => document.removeEventListener("keydown", checkIfPressEsc);
    }
  }, [onClose, open]);
  if (!open || !clientLoaded) return null;
  const content = <TransitionV2 timeout={fullScreen ? 0 : 200} in={open}>
      {state => <div className={`${styles["container"]} ${wrapperClassName || ""} ${state === "entering" || state === "entered" ? styles["container-in"] : styles["container-out"]} ${fullScreen ? "!size-full rounded-none p-0 md:box-content" : ""}`} data-testid="modal-container" onClick={onClose}>
          <div role="dialog" data-full-width={fullWidth} aria-labelledby={ariaLabelledby} aria-describedby={ariaDescribedby} aria-modal={true} onClick={stopPropagationOnModal} id={id} className={`${styles["modal"]} ${className || ""} ${styles[mobileHeight || "full"]} ${animate === "bottom" ? `${styles["bottom"]} ${state === "entered" ? styles["modal-in"] : styles["modal-out"]}` : ""} ${fullScreen ? "!size-full rounded-none p-0 md:box-content" : ""}`} tabIndex={0}>
            {showCloseButton || title ? <div className={`${headerStyle} ${styles["header"]}`}>
                {title ? <h6 className={`${styles["title"]} ${titleClassName} ${showCloseButton ? "max-w-[90%]" : ""}`}>
                    {title}
                  </h6> : ""}
                {showCloseButton ? <MaterialIcon className={`${styles["close"]} ${iconClassName || ""}`} name={closeIcon} onClick={onClose} /> : ""}
              </div> : null}
            {children}
          </div>
        </div>}
    </TransitionV2>;
  return usePortal && body.current ? createPortal(content, body.current) : content;
};